(() => {

  const ratingCache = new Map();
  let activeDrawer;
  let shippingController;
  let offerRefresh;
  let refreshAfterAdd = false;
  const ratingController = new AbortController();
  function addRatings(drawer) {
    drawer.querySelectorAll('.ocu-widget-embedded .ocu-product-card__container').forEach(card => {
      const titleElement = card.querySelector('.ocu-name--tooltip[title]');
      const title = titleElement?.getAttribute('title');
      if (!title || card.querySelector('.gg-cart-rating') || card.dataset.ggRatingTitle === title) return;
      card.dataset.ggRatingTitle = title;
      if (!ratingCache.has(title)) {
        const params = new URLSearchParams({section_id:'gg-cart-ratings',type:'product',q:'title:"' + title.replace(/["\\\\]/g, ' ') + '"'});
        const root = window.Shopify?.routes?.root || '/';
        ratingCache.set(title, fetch(root + 'search?' + params, {headers:{Accept:'text/html'}, signal: ratingController.signal}).then(response => response.ok ? response.text() : '').then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const match = [...doc.querySelectorAll('[data-gg-product-rating]')].find(el => el.dataset.title === title);
          const rating = Number(match?.dataset.rating), count = Number(match?.dataset.count);
          return rating > 0 && count > 0 ? {rating,count} : null;
        }).catch(() => null));
      }
      ratingCache.get(title).then(data => {
        if (!data || !card.isConnected || card.querySelector('.gg-cart-rating') || titleElement.getAttribute('title') !== title) return;
        const rating = document.createElement('div');
        rating.className = 'gg-cart-rating';
        rating.setAttribute('aria-label', data.rating + ' out of 5 stars, ' + data.count + ' reviews');
        const star = document.createElement('span');
        star.textContent = '★';
        star.setAttribute('aria-hidden','true');
        const count = document.createElement('span');
        count.className = 'gg-cart-rating__count';
        count.textContent = '(' + data.count + ')';
        rating.append(star, document.createTextNode(' ' + data.rating.toFixed(2) + ' '), count);
        titleElement.after(rating);
      });
    });
  }

  const states = new WeakMap();
  let timer;
  let shippingRequest;
  let cartSignature = '';
  const pending = new Map();
  document.addEventListener('click', event => {
    if (event.target.closest('.gg-checkout-direct')) {
      clearTimeout(offerRefresh);
      clearTimeout(shippingRequest);
      return; // Native link navigation; no persistent checkout lock or intercepted click.
    }
    const button = event.target.closest('.ocu-widget-embedded .ocu-product-add__button');
    if (!button) return;
    if (button.hasAttribute('data-gg-adding')) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    refreshAfterAdd = true;
    button.setAttribute('data-gg-adding', '');
    button.setAttribute('aria-busy', 'true');
    const timeout = setTimeout(() => { button.removeAttribute('data-gg-adding'); button.removeAttribute('aria-busy'); pending.delete(button); }, 15000);
    pending.set(button, timeout);
  }, true);

  let upsellSequence = 0;
  const upsellBindings = new WeakMap();
  function compactMobileUpsells(drawer) {
    drawer.querySelectorAll('.gg-cart-upsell-toggle').forEach(button => {
      if (button.nextElementSibling !== document.getElementById(button.getAttribute('aria-controls'))) button.remove();
    });
    drawer.querySelectorAll('.ocu-cart-footer .ocu-widget-embedded').forEach(widget => {
      widget.classList.add('gg-mobile-upsell');
      const previousToggle = widget.previousElementSibling;
      if (previousToggle?.classList.contains('gg-cart-upsell-toggle')) {
        if (upsellBindings.get(widget) === previousToggle) {
          widget.dataset.ggCollapsed = String(previousToggle.getAttribute('aria-expanded') !== 'true');
          return;
        }
        previousToggle.remove();
      }
      const title = widget.querySelector('.ocu-title-embedded')?.textContent.trim();
      if (!title) return;
      widget.classList.add('gg-mobile-upsell');
      widget.dataset.ggCollapsed = 'false';
      if (!widget.id) widget.id = 'GGCartUpsell-' + (++upsellSequence);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gg-cart-upsell-toggle';
      button.setAttribute('aria-controls', widget.id);
      button.setAttribute('aria-expanded', 'true');
      const label = document.createElement('span');
      label.textContent = title;
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '−';
      button.append(label, icon);
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        widget.dataset.ggCollapsed = String(!expanded);
        icon.textContent = expanded ? '−' : '+';
      });
      widget.before(button);
      upsellBindings.set(widget, button);
    });
  }

  function update() {
    const drawer = activeDrawer;
    if (!drawer?.isConnected) return;
    const nativeCheckout = drawer.querySelector('.ocu-checkout-button');
    if (nativeCheckout && !drawer.querySelector('.gg-checkout-direct')) {
      const link = document.createElement('a');
      link.className = 'gg-checkout-direct';
      link.href = (window.Shopify?.routes?.root || '/') + 'checkout';
      link.textContent = 'Checkout';
      nativeCheckout.before(link);
    }
    addRatings(drawer);
    compactMobileUpsells(drawer);
    drawer.querySelectorAll('.ocu-widget-embedded').forEach(widget => {
      const cards = [...widget.querySelectorAll('.ocu-product-card__container')];
      const signature = cards.map(card => card.querySelector('[title]')?.getAttribute('title') || card.textContent.trim()).join('|');
      const previous = states.get(widget);
      widget.classList.toggle('gg-offers-empty', cards.length === 0);
      if (previous !== signature) {
        states.set(widget, signature);
        const first = widget.querySelector('.ocu-carousel-indicators__slide');
        if (previous && first && !first.classList.contains('ocu-carousel-indicators__slide--active')) first.click();
        const scroller = widget.querySelector('.ocu-carousel__scroller');
        if (scroller) scroller.scrollLeft = 0;
      }
    });
    const lines = drawer.querySelector('.ocu-cart-line-items');
    const signature = (lines?.textContent || '') + '|' + (drawer.querySelector('.ocu-estimated-info__value')?.textContent || '');
    if (signature !== cartSignature) {
      const shouldRefreshOffers = refreshAfterAdd && cartSignature !== '';
      cartSignature = signature;
      refreshAfterAdd = false;
      if (shouldRefreshOffers) {
        clearTimeout(offerRefresh);
        offerRefresh = setTimeout(() => {
          if (activeDrawer?.isConnected) {
            // OCU's supported refresh also rebuilds the embedded offer after acceptance.
            window.dispatchEvent(new Event('ocu:cart:open:updated'));
          }
        }, 400);
      }
      pending.forEach((timeout, button) => { clearTimeout(timeout); button.removeAttribute('data-gg-adding'); button.removeAttribute('aria-busy'); });
      pending.clear();
      clearTimeout(shippingRequest);
      shippingRequest = setTimeout(updateShipping, 300);
    }
  }
  async function updateShipping() {
    shippingController?.abort();
    shippingController = new AbortController();
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, signal: shippingController.signal});
      if (!response.ok) return;
      const cart = await response.json();
      const drawer = document.querySelector('.ocu-cart-drawer');
      if (!drawer) return;
      let banner = drawer.querySelector('.gg-cart-shipping');
      if (cart.currency !== 'USD' || !cart.item_count) { if (banner) banner.hidden = true; return; }
      if (!banner) {
        banner = document.createElement('div');
        banner.className = 'gg-cart-shipping';
        banner.setAttribute('role', 'status');
        banner.innerHTML = '<p></p><div class="gg-cart-shipping__track"><span></span></div>';
        drawer.querySelector('.ocu-cart-header').after(banner);
      }
      banner.hidden = false;
      const remaining = Math.max(0, 9900 - cart.total_price);
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:cart.currency}).format(remaining / 100);
      banner.querySelector('p').textContent = remaining ? 'Spend ' + amount + ' more to reach free shipping!' : 'You are eligible for free shipping.';
      banner.querySelector('span').style.width = Math.min(100, cart.total_price / 9900 * 100) + '%';
    } catch (_) { /* Keep the cart functional if the progress request is unavailable. */ }
  }
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(update, 120);
  });
  function bindDrawer() {
    const drawer = document.querySelector('.ocu-cart-drawer');
    if (!drawer || drawer === activeDrawer) return;
    observer.disconnect();
    activeDrawer = drawer;
    observer.observe(drawer, {childList: true, subtree: true, characterData: true});
    update();
  }
  // Discovery only reacts to inserted or removed drawer elements, not other app updates.
  const discovery = new MutationObserver(records => {
    if (activeDrawer?.isConnected) return;
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('.ocu-cart-drawer') || node.querySelector('.ocu-cart-drawer'))
    ))) bindDrawer();
  });
  discovery.observe(document.body, {childList: true, subtree: true});
  bindDrawer();
})();